<template>
  <div class="tw:flex tw:items-center tw:gap-4 tw:h-9 tw:text-white">
    <button class="tw:px-2 tw:rounded-md button-bg" @click="setMin">Min</button>
    <div class="tw:flex tw:items-stretch">
      <button class="tw:px-1 tw:rounded-l-md tw:w-5 button-bg" @click="decrement">-</button>
      <div class="tw:min-w-20">
        <input
          v-model="value"
          type="number"
          :min
          :max="max ? new BigNumber(max).toString() : undefined"
          :step
          class="tw:w-full tw:h-full tw:text-center tw:appearance-none no-spin input-bg"
        />
      </div>
      <button class="tw:px-1 tw:rounded-r-md tw:w-5 button-bg" @click="increment">+</button>
    </div>
    <button class="tw:px-2 tw:rounded-md button-bg" @click="setMax">Max</button>
  </div>
</template>

<script lang="ts" setup>
import { BigNumber } from 'bignumber.js';

const {
  min = 0,
  max,
  step = 1,
  format
} = defineProps<{
  min?: number;
  max?: number | BigNumber;
  step?: number;
  format?: (value: string) => string;
}>();

const value = defineModel<string>({ default: '0' });

function increment() {
  if (max && new BigNumber(value.value).plus(step).gt(max)) return;
  value.value = (parseFloat(value.value) + step).toFixed(2);
}
function decrement() {
  if (parseFloat(value.value) - step < min) return;
  value.value = (parseFloat(value.value) - step).toFixed(2);
}
const setMin = () => (value.value = min?.toString() ?? '0');
const setMax = () => (value.value = (max ?? 0).toString());

watch(value, (newValue) => {
  if (format) {
    value.value = String(format(String(newValue)));
  }
});
</script>

<style scoped>
.button-bg {
  background: linear-gradient(180deg, #0083ad 0%, #00354f 100%), #081b25;
}

.input-bg {
  background: radial-gradient(100% 100% at 50% 110%, rgba(0, 131, 173, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
}
</style>
